<template>
  <a-card title="线上运营离职">
    <a-form style="margin-bottom: 16px;">
      <a-form-item label="手机号">
        <a-textarea
          v-model:value="phones"
          placeholder="手机号，多个使用,分开"
          :rows="4"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" danger @click="handleDelete">
          一键删除
        </a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
import { defineComponent } from 'vue'
import { message, Modal } from 'ant-design-vue'
import request from '@/utils/request'

export default defineComponent({
  components: {},
  data() {
    return {
      phones: '',
    }
  },
  methods: {
    handleDelete() {
      if (!this.phones || !this.phones.trim()) {
        message.warning('请输入手机号')
        return
      }

      Modal.confirm({
        title: '确认删除',
        content: '将删除对应用户的内部用户身份和会员，确认是否删除？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          try {
            const phones = this.phones.trim()
            if (!phones) {
              message.warning('请输入有效的手机号')
              return
            }

            await request.post('/api/vips/expired', {
              phones: phones
            })
            message.success('删除成功')
            this.phones = ''
          } catch (error) {
            console.error('删除失败:', error)
            message.error('删除失败，请重试')
          }
        }
      })
    }
  }
})
</script>